import qs from 'qs'
import { HTTP } from './helpers/http.js'

export default {
  getAllAuditLogs(filters, page, limit, sort) {
    return HTTP.post('/api/v1/audit', {
      filters,
      page,
      limit,
      sort,
    })
  },

  getOrganizationAuditLogs(organizationId, filters, page, limit, sort) {
    return HTTP.post(`/api/v1/audit/organizations/${organizationId}`, {
      filters,
      page,
      limit,
      sort,
    })
  },

  getAccountAuditLogs(organizationId, accountId, filters, page, limit, sort) {
    return HTTP.post(
      `/api/v1/audit/organizations/${organizationId}/accounts/${accountId}`,
      {
        filters,
        page,
        limit,
        sort,
      }
    )
  },

  getRevLogs(args = {}) {
    const { organizationId, revId, type, page, sort, limit = 10 } = args

    return HTTP.get(
      `/api/v1/audit/organizations/${organizationId}/revs/${revId}?type=${type}`,
      {
        params: { page, limit, sort },
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },

  getRoutineLogs(args = {}) {
    const { organizationId, routineId, page, sort, limit = 10 } = args

    return HTTP.get(
      `/api/v1/audit/organizations/${organizationId}/routines/${routineId}`,
      {
        params: { page, limit, sort },
        paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      }
    )
  },
}
